import type { ReactNode } from "react";

/** Page header (U5) -- now HEADLESS. Dattatray, 2026-10-28: *"Let's get rid
 *  of subpage header ... from every page"*: the eyebrow ("Fleet · Overview"),
 *  the h1 ("Devices reporting now") and the description paragraph are no
 *  longer drawn. The tab row above already names the page.
 *
 *  THREE THINGS SURVIVE, deliberately:
 *    `right`   nine pages hang real controls here -- Back, Export CSV, the
 *              broker-live pill, the Enroll selector, Fleet's way out of a
 *              focused visit. They render as a right-aligned row.
 *    the h1    kept, visually hidden. A screen reader still gets a page
 *              name, and the D-84 render tests identify WHICH tab rendered
 *              by its heading -- that is how "subpages showing each other's
 *              contents" was caught, and it must stay catchable.
 *    the props every page still passes eyebrow/title/desc, so the text is
 *              one line away if the header comes back; `tests/ui` keeps
 *              requiring the component on every routed page.
 */
export function PageHead({ title, right }: {
  eyebrow: string; title: string; desc?: ReactNode; right?: ReactNode;
}) {
  return (
    <>
      <h1 className="sr-only">{title}</h1>
      {right && <div className="pagehead">{right}</div>}
    </>
  );
}
